import { render, staticRenderFns } from "./description.vue?vue&type=template&id=228acc7e&scoped=true&"
import script from "./description.vue?vue&type=script&lang=ts&"
export * from "./description.vue?vue&type=script&lang=ts&"
import style0 from "./description.vue?vue&type=style&index=0&id=228acc7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228acc7e",
  null
  
)

export default component.exports